var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageLoader'),_c('v-app',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"min-height":"90vh"},style:({
        'padding-top': _vm.$vuetify.breakpoint.name == 'xs' ? '0px' : '0px',
      })},[_c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath})],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }